import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Leaf } from "lucide-react";

export default function Login() {
  const { t } = useTranslation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const handleGoogle = () => {
    const redirectUrl = window.location.origin + "/home";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <main className="app-shell flex flex-col">
      {/* Hero image — Sunflower (Helianthus annuus), native to North America */}
      <div className="relative h-[58dvh] overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1597848212624-a19eb35e2651?auto=format&fit=crop&w=900&q=80"
          alt="Sunflower field — Helianthus annuus, native to North America"
          className="absolute inset-0 w-full h-full object-cover"
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src =
              "https://images.unsplash.com/photo-1772602841938-2f07739e58fe?auto=format&fit=crop&w=900&q=80";
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#FDFBF7]/0 via-[#FDFBF7]/25 to-[#FDFBF7]" />
        <div className="absolute top-6 left-6 flex items-center gap-2">
          <Leaf className="w-5 h-5 text-leaf" strokeWidth={1.5} />
          <span className="font-display text-lg text-leaf-ink">{t("app.name")}</span>
        </div>
      </div>

      <div className="flex-1 px-7 md:px-10 -mt-10 pb-10 flex flex-col animate-fade-up md:max-w-2xl md:mx-auto md:w-full">
        <h1 className="font-display text-4xl sm:text-5xl md:text-6xl text-leaf-ink leading-[1.05] tracking-tight">
          {t("login.heroLine1")}<br />
          <span className="italic text-leaf">{t("login.heroLine2")}</span>
        </h1>

        <p className="mt-5 text-sm md:text-base text-leaf-mist leading-relaxed max-w-[42ch]">
          {t("login.subtitle")}
        </p>

        <p className="mt-3 text-xs text-leaf-deep/80 uppercase tracking-[0.18em] font-medium">
          {t("login.tagline")}
        </p>

        <div className="mt-auto pt-10">
          <button
            onClick={handleGoogle}
            data-testid="google-signin-button"
            className="w-full bg-leaf hover:bg-leaf-deep text-white rounded-full py-4 px-6 flex items-center justify-center gap-3 font-medium tracking-wide transition-all active:scale-[0.98] shadow-botanicalLg"
          >
            <GoogleIcon />
            <span>{t("login.google")}</span>
          </button>

          <div className="flex items-center justify-center gap-4 mt-4 text-[11px] text-leaf-deep uppercase tracking-[0.18em] font-medium">
            <Link to="/about" data-testid="login-about" className="hover:text-leaf">{t("login.about")}</Link>
            <span className="text-leaf-mist">·</span>
            <Link to="/privacy" data-testid="login-privacy" className="hover:text-leaf">{t("login.privacy")}</Link>
            <span className="text-leaf-mist">·</span>
            <Link to="/terms" data-testid="login-terms" className="hover:text-leaf">{t("login.terms")}</Link>
          </div>
        </div>
      </div>
    </main>
  );
}

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.4 29.3 35.5 24 35.5c-6.4 0-11.5-5.2-11.5-11.5S17.6 12.5 24 12.5c2.9 0 5.6 1.1 7.6 2.9l5.7-5.7C33.6 6.3 29.1 4.5 24 4.5 13.2 4.5 4.5 13.2 4.5 24S13.2 43.5 24 43.5 43.5 34.8 43.5 24c0-1.2-.1-2.4-.4-3.5z"/>
    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 12.5 24 12.5c2.9 0 5.6 1.1 7.6 2.9l5.7-5.7C33.6 6.3 29.1 4.5 24 4.5 16.3 4.5 9.7 8.8 6.3 14.7z"/>
    <path fill="#4CAF50" d="M24 43.5c5 0 9.5-1.7 13-4.6l-6-5c-2 1.4-4.4 2.1-7 2.1-5.3 0-9.7-3.1-11.3-7.5l-6.5 5C9.7 39.2 16.3 43.5 24 43.5z"/>
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.2-4.3 5.5l6 5c-.4.4 6.5-4.7 6.5-14.5 0-1.2-.1-2.4-.4-3.5z"/>
  </svg>
);
